import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% {   opacity: 0.6; }
  50% {  opacity: 1.0; }
  100% { opacity: 0.6; }
`

const Placeholder = styled.div`
  background-color: ${props => props.theme.colors.gray300};
  width: 100%;
  height: 100%;
  animation: ${pulse} 1.5s infinite;
`

export default Placeholder
